import { useMutation, useQueryClient } from '@tanstack/react-query';

import { uploadTeamFile as uploadTeamFileAPI } from '@/api/v4/team-files.api';
import { QueryKey } from '@/config/query-client';

import { teamIdState } from '../../../team.state';
import { useAtomValue } from 'jotai';

export const useUploadTeamFile = () => {
  const queryClient = useQueryClient();
  const teamId = useAtomValue(teamIdState);

  const mutation = useMutation({
    mutationFn: uploadTeamFileAPI,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamFiles, teamId],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamActionsInfo, teamId],
      });
    },
    onError: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamFiles, teamId],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamActionsInfo, teamId],
      });
    },
  });

  const uploadTeamFile = (files: File[]) => {
    if (!teamId) return;

    return mutation.mutateAsync({ teamId, files });
  };

  return {
    uploadTeamFile,
    isError: mutation.isError,
  };
};
